import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HomeSearch from "./components/HomeSearch";
import Features from "./components/Features";
import Bikes from "./components/Bikes";
import Locations from "./components/Locations";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import SEO from "./components/SEO";
import TermsConditions from "./pages/TermsConditions";
import Search from "./pages/Search";
import Book from "./pages/Book";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import EmployeePortal from "./pages/EmployeePortal";
import { Toaster } from "./components/ui/toaster";

const Home = () => {
  return (
    <div className="bg-white text-neutral-900 antialiased">
      <SEO
        title="RR Bros Bike Rental | Bike & Scooty Rental in Udupi, Manipal"
        description="Book bike & scooty rental in Udupi and Manipal at RR Bros. Honda Activa 6G, Yamaha Fascino 125 and Yamaha Ray-Z. Self drive, one helmet free, flexible km plans."
        canonical="https://ezrental.in/"
        keywords="Bike Rental in Udupi, Bike Rental in Manipal, Scooty Rental Udupi, Scooty Rental Manipal, Rent Bike Udupi, Two Wheeler Rental Udupi, Bike Hire Udupi, Motorcycle Rental Manipal, Self Drive Bike Rental Udupi, RR Bros Bike Rental"
      />
      <Header />
      {/*
        HomeSearch sits at the very top so a visitor immediately sees the
        pickup/date/time search panel (mobile-first).
      */}
      <main className="flex flex-col">
        <div className="order-1">
          <HomeSearch />
        </div>
        <div className="order-3 lg:order-2">
          <Hero />
        </div>
        <div className="order-4 lg:order-3">
          <Features />
        </div>
        <div className="order-2 lg:order-4">
          <Bikes />
        </div>
        <div className="order-5">
          <Locations />
        </div>
        <div className="order-6">
          <FAQ />
        </div>
        <div className="order-7">
          <Contact />
        </div>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<Search />} />
          <Route path="/book" element={<Book />} />
          <Route path="/terms" element={<TermsConditions />} />
          {/* Private admin routes — intentionally not linked anywhere public */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          {/* Private employee portal — login + authed portal on a single hidden URL */}
          <Route path="/employee" element={<EmployeePortal />} />
          <Route path="/employee/login" element={<EmployeePortal />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
